import { FC, useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import useCollapseDrawer from "src/hooks/useCollapseDrawer";
import { HEADER, NAVBAR } from "src/config/config";
import Header from "./header";
import NavbarVertical from "./navbar/NavbarVertical";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type RootStyleProps = {
    collapseClick: boolean;
};

const RootStyle = styled("div", {
    shouldForwardProp: (prop) => prop !== "collapseClick",
})<RootStyleProps>(({ collapseClick, theme }) => ({
    flexGrow: 1,
    display: "flex",
    paddingTop: HEADER.MOBILE_HEIGHT + 24,
    minHeight: "calc(100vh)",
    [theme.breakpoints.up("lg")]: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: 24 + HEADER.DASHBOARD_DESKTOP_HEIGHT,
        // paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
        // width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
        transition: theme.transitions.create("margin-left", {
            duration: theme.transitions.duration.shorter,
        }),
        ...(collapseClick && {
            marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
        }),
    },
}));

const Footer = styled("footer")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(4, 0),
}));

const MainLayout: FC = () => {
    const { t } = useTranslation();
    const { collapseClick, isCollapse } = useCollapseDrawer();
    const [open, setOpen] = useState(false);

    return (
        <Box
            sx={{
                display: { lg: "flex" },
                minHeight: "100%",
            }}
        >
            <Header isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} />
            <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
            <RootStyle collapseClick={collapseClick}>
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                    <Outlet />
                    <Footer>
                        <Typography
                            variant="caption"
                            sx={{
                                color: "text.disabled",
                                textAlign: "center",
                                textTransform: "uppercase",
                                letterSpacing: 1.1,
                            }}
                        >
                            {t("shared.copyright").replace(":year", new Date().getFullYear())}
                        </Typography>
                    </Footer>
                </Box>
            </RootStyle>
        </Box>
    );
};

export default MainLayout;
